// extracted by mini-css-extract-plugin
export var about = "About-module--about--1G3LL";
export var grid = "About-module--grid--2VoJc";
export var info__item = "About-module--info__item--QJwZk";
export var info__label = "About-module--info__label--2F9yC";
export var info__value = "About-module--info__value--1J1Sw";
export var content__paragraph = "About-module--content__paragraph--3InMu";
export var info = "About-module--info--1WrGn";